import { makeStyles, useTheme } from '@material-ui/core/styles';
export const useStyles = makeStyles(theme => ({

  wrapper:{
    marginTop: '60px'
  },
    createNewBtn: {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
          padding: '0 0 10px 14px'
        }
      },
      btnTitle: {
        paddingRight: '10px',
        color: '#0E8BB4'
      },
      createNewIcon: {
        fill: '#0E8BB4',
        width: '19px',
        height: '19px',
        marginRight: '5px'
      },
}));